<template>
  <!-- -->
  <div class="separator-page"  :class="(showBorder? ' border': ' no-border') + (showShadow? ' shadow': ' no-shadow')" :style="{'--right-background': rightBackGround}">
    <div class="separator-div">
      <div class="left">
          <slot name="category"/>
      </div>
      <div class="right"><slot/></div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    // 是否对子组件显示阴影
    showShadow: {default: true},
    // 是否对子组件显示边框，这个阴影和边框适用于子组件，不适用于ListPage本身
    showBorder: {default: false},
    rightBackGround: {default: "#FFF"}
  },
  name: "SeparatorPage",
  components: {
  },
  data() {
    return {
      show: false
    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.separator-page{
  height: 100%;
  box-sizing: border-box;
  .separator-div{
    display: flex;
    justify-content: space-between;
    height: 100%;
    //border-top: 2px solid var(--yq-border-color);
    .left{
      width: 180px;
      background: #FFF;
      overflow: auto;
      height: 100%;
      margin-right: 10px;
      border-radius: 4px;
      box-sizing: border-box;
    }
    .right{
      flex: 1;
      display: flex;
      flex-direction: column;
      //width: 50%;
      min-width: 0;
      background: var(--right-background);
      border-radius: 4px;
      :deep(.list-table){
        flex: 1;
        height: 50%;
        margin-bottom: 10px;
      }
      :deep(.search-condition) {
        background: #FFF;
        box-sizing: border-box;
        border-radius: 4px;
      }
      :deep(.form-page){
        border-radius: 4px;
      }
      :deep(>*){
        :last-child{
          margin-bottom: 0;
        }
      }
    }
  }
}
// 边框
.separator-page.border{
  .left{
    border: 1px solid var(--yq-border-color);
  }
}
// 阴影
.separator-page.shadow{
  .left{
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .right{
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
}
</style>